<div
  *ngIf="type === 'block'; else rows"
  class="app-skeleton__shine app-skeleton__block"
  [style.height]="height"
  [style.border-radius]="radius"
></div>

<ng-template #rows>
  <div
    *ngIf="alignedRows.length; else evenRows"
    class="app-skeleton__rows app-skeleton__rows--aligned"
    [style.left.px]="alignedLeft"
  >
    <div *ngFor="let row of alignedRows" class="app-skeleton__row" [style.height]="rowHeight">
      <span
        *ngFor="let cell of row"
        class="app-skeleton__shine"
        [class.app-skeleton__cell]="cell.kind === 'text'"
        [class.app-skeleton__box]="cell.kind === 'box'"
        [style.left.px]="cell.left"
        [style.width.px]="cell.width"
      ></span>
    </div>
  </div>
</ng-template>

<ng-template #evenRows>
  <div class="app-skeleton__rows">
    <div *ngFor="let item of items" class="app-skeleton__row" [style.height]="rowHeight">
      <span *ngFor="let width of cells" class="app-skeleton__col">
        <span class="app-skeleton__shine app-skeleton__cell" [style.width.%]="width"></span>
      </span>
    </div>
  </div>
</ng-template>
